import platformBackendClient from '@backend-clients/platform-backend';

export default {
  create: (cid, bucket, payload) => platformBackendClient.post(`/api/support/?company_id=${cid}&bucket=${bucket}`, payload),
};
